import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AnchorLink from 'react-anchor-link-smooth-scroll';

// import { IntlContext } from '../../Providers/Intl';
import { getPathFromSlug } from '../../../utils/helpers';
import { SitemapProvider } from '../Context/SitemapProvider';
import { LocaleProvider } from '../Context/LocaleProvider';

import { InternalStyledLink, ExternalStyledLink, LinkWrapper } from './styles';

const Link = ({
  id,
  className,
  children,
  to,
  ariaLabel,
  external,
  activeClassName,
}) => {
  // const { intl } = useContext(IntlContext);
  // const localePrefix = intl ? `/${intl.path}` : '';
  const sitemap = useContext(SitemapProvider);
  const locale = useContext(LocaleProvider);

  const isJumpLink = /^#/.test(to);
  const isInternal = external ? !/^http/.test(to) : /^\/(?!\/)/.test(to);
  if (external && isInternal) {
    // console.log('WHY IS IT BOTH?', to, isInternal);
  }
  const isSpecialLink = /(mailto:|tel:).*/.test(to);

  let iLink = '';
  if (isInternal) {
    if (sitemap) {
      iLink = getPathFromSlug(sitemap.pages, to, locale).path;
      if (iLink && iLink.indexOf(locale.code) !== -1)
        iLink = iLink.split(`/${locale.code}/`).join('');
      // console.log('LINK DATA', iLink, to);
    }
  }

  if (!children) {
    return null;
  }

  if (isJumpLink) {
    return (
      <AnchorLink
        id={id}
        className={`anchorLink ${className}`}
        href={to}
        aria-label={ariaLabel}
      >
        <span>{children}</span>
      </AnchorLink>
    );
  }
  return isInternal === true && !isSpecialLink ? (
    <InternalStyledLink
      id={id}
      className={`internalStyledLink ${className}`}
      to={
        iLink !== '' && iLink !== undefined
          ? `/${locale.code}${iLink.substr(0, 1) === '/' ? iLink : `/${iLink}`}`
          : to
      }
      aria-label={ariaLabel}
      activeClassName={activeClassName}
    >
      <LinkWrapper title={typeof children === 'string' ? children : ariaLabel}>
        {children}
      </LinkWrapper>
    </InternalStyledLink>
  ) : (
    <ExternalStyledLink
      id={id}
      className={`externalStyledLink ${className}`}
      href={to}
      aria-label={ariaLabel}
      isSpecialLink={isSpecialLink}
    >
      <LinkWrapper title={typeof children === 'string' ? children : ''}>
        {children}
      </LinkWrapper>
    </ExternalStyledLink>
  );
};

Link.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  to: PropTypes.string,
  ariaLabel: PropTypes.string,
  external: PropTypes.bool,
  activeClassName: PropTypes.string,
};

Link.defaultProps = {
  id: null,
  className: '',
  to: '/',
  ariaLabel: null,
  external: false,
  activeClassName: '',
};

export default Link;
